import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "clientId", "isDisabled", "onClick", "onDoubleClick"];
import React, { forwardRef, useCallback } from "react";
import { useFocusMode } from "../../focusMode";
import { ToastActionStyled } from "../styled/ToastActionStyled";
/**
 * @deprecated please use @smartsheet/sds-toast-state-service instead. See
 * https://static.smart.ninja/storybook/team-ui-engineering/lodestar-core/mainline/sds-toast-ui/storybook/index.html
 */
export var ToastAction = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    clientId = _ref.clientId,
    isDisabled = _ref.isDisabled,
    providedOnClick = _ref.onClick,
    providedOnDoubleClick = _ref.onDoubleClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var onClick = useCallback(function (e) {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnClick) {
      providedOnClick(e);
    }
  }, [isDisabled, providedOnClick]);
  var onDoubleClick = useCallback(function (e) {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnDoubleClick) {
      providedOnDoubleClick(e);
    }
  }, [isDisabled, providedOnDoubleClick]);
  var _useFocusMode = useFocusMode(),
    focusMode = _useFocusMode.focusMode;
  return /*#__PURE__*/React.createElement(ToastActionStyled, _extends({
    focusMode: focusMode,
    tabIndex: 0,
    "aria-disabled": isDisabled,
    onClick: onClick,
    onDoubleClick: onDoubleClick,
    type: "button",
    "data-client-id": clientId
  }, rest, {
    ref: ref
  }), children);
});
ToastAction.displayName = "ToastAction";
//# sourceMappingURL=ToastAction.js.map